import { countryDisplayNameFromIso } from "@faire/retailer-visitor-shared/lib/countryDisplayNameFromIso";
import {
  DEPRECATED_backwardsCompatibleValues,
  useStrictLocalization,
} from "@faire/web--source/common/localization/localize";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { observer } from "mobx-react";
import * as React from "react";

const BrandShippingLocationTextBase: React.FC<{
  shipsFromCountry?: string;
}> = ({ shipsFromCountry }) => {
  const { strictLocalize } = useStrictLocalization();
  const countryName =
    shipsFromCountry &&
    countryDisplayNameFromIso(shipsFromCountry, strictLocalize);
  if (!countryName) {
    return null;
  }

  return (
    <StrictLocalMsg
      defaultMessage="Ships from {countryName}"
      description={{
        text: "Shows where brand will ship product from. i.e. Ships from Switzerland.",
      }}
      values={DEPRECATED_backwardsCompatibleValues({
        countryName: countryName,
      })}
    />
  );
};

export const BrandShippingLocationText = observer(
  BrandShippingLocationTextBase
);
